<template>
  <div class="space-between-y">
    <div v-for="(item, index) in access" :key="index">
      <div class="access-type">{{ item.type }}</div>
      <el-checkbox-group v-model="checkAccess">
        <el-checkbox v-for="(accessItem, idx) in item.list" :key="idx" :label="accessItem.code">
          {{ accessItem.name }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="container-center">
      <el-button @click="selectAll(true)">全选</el-button>
      <el-button @click="selectAll(false)">全不选</el-button>
      <el-button type="primary" @click="submitAccess">保存</el-button>
    </div>
  </div>
</template>

<script>
import {role} from "@/api/role";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'RoleAccessUpdate',
  props: {
    roleId: Number
  },

  data() {
    return {
      access: [],
      checkAccess: [],
    };
  },

  created() {
    // 获取所有的权限列表
    role.listAccess().then(list => {
      this.access = list;
    });

    // 获取该角色已经选中的权限codes
    role.listRoleAccess(this.roleId).then(codes => {
      this.checkAccess = codes;
    });
  },

  methods: {
    selectAll(flag) {
      this.checkAccess = flag ? this.access.map(item => item.list.map(item => item.code)).flat() : [];
    },

    submitAccess() {
      // 将更新后的权限codes提交到后端
      role.updateRoleAccess(this.roleId, this.checkAccess).then(res => {
        msg(res, this);
        if (res.code === 200) {
          this.$emit('updated');
        }
      });
    }
  }
};
</script>

<style scoped>
.access-type {
  font-size: 15px;
  font-weight: bold;
  border-bottom: #c8c8c8 1px solid;
  padding-bottom: 2px;
  margin-bottom: 6px;
  margin-top: 6px;
}
</style>
